import Vue from 'vue'
import Vuex from 'vuex'
import * as D3 from 'd3'
import 'isomorphic-fetch'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    attributes: null,
    geo: null,
    data: [],
    views: [],
    selectedXAttribute: null,
    selectedYAttribute: null,
    languages: ["EN", "NL"],
    currentLanguage: "",
    idSelectedCounty: null,
    labels: null,
    gemeenten: [],
    selectedGemeente: null,
    loadingData: false
  },
  getters: {
    attributes: state => state.attributes,
    geo: state => state.geo,
    data: state => state.data,
    selectedXAttribute: state => state.selectedXAttribute,
    selectedYAttribute: state => state.selectedYAttribute,
    languages: state => state.languages,
    currentLanguage: state => state.currentLanguage,
    idSelectedCounty: state => state.idSelectedCounty,
    labels: state => state.labels,
    gemeenten: state => state.gemeenten,
    selectedGemeente: state => state.selectedGemeente,
    loadingData: state => state.loadingData
  },
  mutations: {
    SET_GEO: (state, payload) => {
      state.geo = payload;
    },
    SET_DATA: (state, payload) => {
      state.data = payload;
    },
    SET_ATTRIBUTES: (state, payload) => {
      state.attributes = payload;
    },
    SET_VIEWS: (state, payload) => {
      state.views = payload;
    },
    SET_SELECTED_X_ATTRIBUTE: (state, payload) => {
      state.selectedXAttribute = payload;
    },
    SET_SELECTED_Y_ATTRIBUTE: (state, payload) => {
      state.selectedYAttribute = payload;
    },
    SET_CURRENT_LANGUAGE: (state, payload) => {
      state.currentLanguage = payload;
    },
    SET_ID_SELECTED_COUNTY: (state, payload) => {
      state.idSelectedCounty = payload;
    },
    SET_LABELS: (state, payload) => {
      state.labels = payload;
    },
    SET_GEMEENTEN: (state, payload) => {
      state.gemeenten = payload;
    },
    SET_SELECTED_GEMEENTE: (state, payload) => {
      state.selectedGemeente = payload;
    },
    SET_LOADING_DATA: (state, payload) => {
      state.loadingData = payload;
    }
  },
  actions: {
    init: (context) => {
      Promise.all([
        fetch("./data/attributes.json")
          .then(result => result.json()),
        fetch("./data/labels.json")
          .then(result => result.json()),
        fetch("./data/gemeenten.json")
          .then(result => result.json())
      ])
      .then(results => {
        console.log("read");
        const attributes = results[0];
        const labels = results[1];
        const gemeenten = results[2];

        context.commit("SET_ATTRIBUTES", attributes);
        context.commit("SET_SELECTED_X_ATTRIBUTE", attributes[0].attributes[0]); //first attribute from first group
        context.commit("SET_LABELS", labels);
        context.commit("SET_CURRENT_LANGUAGE", context.getters.languages[0]);
        let selectedGemeente = gemeenten.find(g => g.default);
        if (!selectedGemeente) selectedGemeente = gemeenten[0];

        gemeenten.sort((g1, g2) => {
          if (g1.name < g2.name) return -1;
          if (g1.name > g2.name) return 1;
          return 0;
        });

        context.commit("SET_GEMEENTEN", gemeenten);
        context.commit("SET_SELECTED_GEMEENTE", selectedGemeente);
        context.dispatch('readGemeenteData', selectedGemeente);
      })
    },
    readGemeenteData: (context, gemeente) => {
      context.commit("SET_LOADING_DATA", true);
      context.commit("SET_GEO", null);
      context.commit("SET_DATA", []);
      Promise.all([
        fetch("./data/" + gemeente.name + "_geo.json")
          .then(result => result.json()),
        fetch("./data/" + gemeente.name + "_data.csv")
          .then(result => result.text())
          .then(text => {
            const psv = D3.dsvFormat(";");
            const data = psv.parse(text);
            return data;
          }),
      ])
      .then(results => {
        const geo = results[0];
        const data = results[1];

        context.commit("SET_GEO", geo);
        context.commit("SET_DATA", data);
        context.commit("SET_LOADING_DATA", false);
      })
    }
  }
})
